import { isLoggedIn } from "../utils/login";

const loginReducer = (state = isLoggedIn(), action) => {
  switch (action.type) {
    case "LOGIN":
      return true;
    case "LOGINADMIN":
      return true;
    case "LOGOUT":
      return false;
    default:
      return state;
  }
};

export default loginReducer;
